import React, { useEffect, useState } from "react";
import {
  fetchExploreDetailApi,
  fetchExploreLikeCommentApi,
  updateCommentVisiblity,
} from "../../services/exploreManagement";
import { Link, useParams, useSearchParams } from "react-router-dom";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";
import { Avatar, IconButton, Switch, Chip, Box, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import VideoPreview from "../../components/videoPreview/VideoPreview";
import NotFound from "../../components/not-found/NotFound";
import { dateFormat } from "../../utils/dateFormat";
import profileImage from "../../Assests/image/profile_not_found.png";
import { CustomTab, CustomTabs } from "../../components/tabs/Tabs";

const ExploreDetail = () => {
  const { id } = useParams();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [searchParam, setSearchParam] = useSearchParams();
  let type = searchParam.get("type") || "LIKE";
  const [exploreDetail, setExploreDetail] = useState({});
  const [likeCommentList, setLikeCommentList] = useState([]);

  const fetchExploreDetail = async () => {
    try {
      showLoader();
      let sendData = { exploreId: id, type: type };
      const { data } = await fetchExploreDetailApi(sendData);
      if (data.code === 200) {
        toastMessage(data.message, "success", "exploreDetail");
        setExploreDetail(data?.result);
      } else {
        toastMessage(data.message, "error", "exploreDetail");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  console.log(exploreDetail, "Explore Detail");
  console.log(exploreDetail?.media, "Media Data");

  const fetchExploreLikeComment = async () => {
    try {
      showLoader();
      let sendData = { exploreId: id, type: type };
      const { data } = await fetchExploreLikeCommentApi(sendData);
      if (data.code === 200) {
        toastMessage(data.message, "success", "likeCOmmentList");
        setLikeCommentList(data?.result?.list);
      } else {
        toastMessage(data.message, "error", "likeCOmmentList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  const typeHandler = (type) => {
    searchParam.set("type", type);
    setSearchParam(searchParam);
  };

  const changeCommentStatus = async (_comment) => {
    try {
      showLoader();
      let sendData = { exploreId: _comment._id, status: !Boolean(_comment.status) };
      await updateCommentVisiblity(sendData);
      fetchExploreLikeComment();
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  }

  useEffect(() => {
    fetchExploreDetail();
  }, []);

  useEffect(() => {
    fetchExploreLikeComment();
  }, [searchParam]);

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <div className="user_detail_heading">
            <Link className="back_icon" to={-2}>
              <IconButton>
                <ArrowBackIosNewIcon className="back_button" />
              </IconButton>
            </Link>
            <h4 className="Title">Explore Details</h4>
          </div>
        </div>

        {/* Post Information */}
        <div className="row mb-4">
          <div className="col-12">
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" component="h2">
                {exploreDetail?.title || "No Title"}
              </Typography>
              <Chip
                label={
                  exploreDetail?.postType === "image" ? "Image Post" :
                  exploreDetail?.postType === "audio" ? "Music Post" : 
                  exploreDetail?.postType === "video" ? "Video Post" : exploreDetail?.postType || "Unknown"
                }
                color={
                  exploreDetail?.postType === "image" ? "primary" :
                  exploreDetail?.postType === "audio" ? "secondary" : 
                  exploreDetail?.postType === "video" ? "success" : "default"
                }
                variant="outlined"
                icon={
                  exploreDetail?.postType === "image" ? <span>📷</span> :
                  exploreDetail?.postType === "audio" ? <span>🎵</span> :
                  exploreDetail?.postType === "video" ? <span>🎥</span> : null
                }
              />
              {exploreDetail?.scheduledAt ? (
                <Chip
                  label="Scheduled"
                  color="warning"
                  variant="outlined"
                  icon={<span>⏰</span>}
                />
              ) : (
                <Chip
                  label="Immediate"
                  color="success"
                  variant="outlined"
                  icon={<span>⚡</span>}
                />
              )}
            </Box>
          </div>
        </div>

        {/* Media Display */}
        <div className="row mb-4">
          <div className="col-12">
            <Typography variant="h6" gutterBottom>Media Content</Typography>
            {exploreDetail?.media && Array.isArray(exploreDetail.media) && exploreDetail.media.length > 0 ? (
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {exploreDetail.media.map((mediaItem, index) => (
                  <div key={index} style={{ position: 'relative', maxWidth: '200px' }}>
                    {mediaItem.type === "video" ? (
                      <div className="video-container">
                        <VideoPreview videoUrl={mediaItem.url} />
                      </div>
                    ) : (
                      <img
                        src={mediaItem.url}
                        alt={`Media ${index + 1}`}
                        style={{
                          width: 200,
                          height: 200,
                          objectFit: 'cover',
                          borderRadius: 8,
                          border: "1px solid #FF8989",
                        }}
                        onError={(e) => {
                          console.error('Image load error:', mediaItem.url);
                          e.target.style.display = 'none';
                        }}
                      />
                    )}
                    {/* Post type indicator */}
                    {exploreDetail?.postType === "audio" && (
                      <div style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        backgroundColor: '#9c27b0',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        color: 'white'
                      }}>
                        🎵
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : exploreDetail?.media?.url ? (
              <div style={{ position: 'relative', maxWidth: '400px' }}>
                {exploreDetail.media.type === "video" ? (
                  <div className="video-container">
                    <VideoPreview videoUrl={exploreDetail.media.url} />
                  </div>
                ) : (
                  <img
                    src={exploreDetail.media.url}
                    alt="Media content"
                    style={{
                      width: "100%",
                      maxWidth: 400,
                      height: 300,
                      objectFit: 'cover',
                      borderRadius: 8,
                      border: "1px solid #FF8989",
                    }}
                    onError={(e) => {
                      console.error('Image load error:', exploreDetail.media.url);
                      e.target.style.display = 'none';
                    }}
                  />
                )}
              </div>
            ) : (
              <Typography color="textSecondary">No media available</Typography>
            )}
          </div>
        </div>

        {/* Description */}
        <div className="row mb-4">
          <div className="col-12">
            <Typography variant="h6" gutterBottom>Description</Typography>
            <Typography variant="body1" paragraph>
              {exploreDetail?.description || "No description available"}
            </Typography>
          </div>
        </div>
        {/* Post Details */}
        <div className="row mb-4">
          <div className="col-md-6">
            <Typography variant="h6" gutterBottom>Hashtag</Typography>
            <Typography variant="body1" paragraph>
              {exploreDetail?.hastag || "No hashtag"}
            </Typography>
          </div>
          <div className="col-md-6">
            <Typography variant="h6" gutterBottom>Status</Typography>
            <Chip
              label={exploreDetail?.status ? "Active" : "Inactive"}
              color={exploreDetail?.status ? "success" : "error"}
              variant="outlined"
            />
          </div>
        </div>

        {/* Scheduling Information */}
        <div className="row mb-4">
          <div className="col-md-6">
            <Typography variant="h6" gutterBottom>Created Date</Typography>
            <Typography variant="body1">
              {dateFormat(exploreDetail?.createdAt) || "---"}
            </Typography>
          </div>
          <div className="col-md-6">
            {exploreDetail?.scheduledAt && (
              <>
                <Typography variant="h6" gutterBottom>Scheduled Date</Typography>
                <Typography variant="body1">
                  {dateFormat(exploreDetail.scheduledAt)} at {new Date(exploreDetail.scheduledAt).toLocaleTimeString()}
                </Typography>
              </>
            )}
            {exploreDetail?.publishedAt && (
              <>
                <Typography variant="h6" gutterBottom>Published Date</Typography>
                <Typography variant="body1">
                  {dateFormat(exploreDetail.publishedAt)} at {new Date(exploreDetail.publishedAt).toLocaleTimeString()}
                </Typography>
              </>
            )}
          </div>
        </div>

        {/* Audio Information for Music Posts */}
        {exploreDetail?.postType === "audio" && exploreDetail?.media && (
          <div className="row mb-4">
            <div className="col-12">
              <Typography variant="h6" gutterBottom>Audio Content</Typography>
              {Array.isArray(exploreDetail.media) ? (
                exploreDetail.media.map((mediaItem, index) => (
                  mediaItem.music && (
                    <div key={index} style={{ marginBottom: '10px' }}>
                      <audio controls style={{ width: '100%', maxWidth: '400px' }}>
                        <source src={mediaItem.music} type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    </div>
                  )
                ))
              ) : (
                exploreDetail.media.music && (
                  <audio controls style={{ width: '100%', maxWidth: '400px' }}>
                    <source src={exploreDetail.media.music} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                )
              )}
            </div>
          </div>
        )}

        <div
          className="col-form-label mx-auto mt-3"
        >
          <CustomTabs
            value={type}
            onChange={(e, section) => {
              typeHandler(section);
            }}
            aria-label="Content"
            variant="fullWidth"
          >
            <CustomTab value="LIKE" label="Like" />
            <CustomTab value="COMMENT" label="Comment" />
          </CustomTabs>
        </div>

        <div className="row">
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Profile</th>
                  <th>Name</th>
                  <th>Email Id</th>
                  <th>Date</th>
                  {type == 'COMMENT' && <>
                    <th>Comment</th>
                    <th>Action(s)</th>
                  </>}
                </tr>
              </thead>
              <tbody>
                {likeCommentList.length > 0 ? (
                  likeCommentList.map((offers, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{++index}</td>
                          <td className="user_profile_image">
                            <img
                              src={offers?.userDetails?.image || profileImage}
                              alt={`${index + 1}-${offers?.userDetails?.name} profile image`}
                            />
                          </td>
                          <td>{offers?.userDetails?.name || "---"}</td>
                          <td>{offers?.userDetails?.email || "---"}</td>
                          <td>{dateFormat(offers.createdAt) || "---"} </td>


                          {type == 'COMMENT' && <>
                            <td>{offers?.comment || "-- No comment--"}</td>
                            <td>
                              <Switch
                                checked={offers?.status}
                                onChange={() => {
                                  changeCommentStatus(offers);
                                }}
                              />
                            </td>
                          </>}

                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound cols={8} msg="Request not found!" loader={loader} />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreDetail;
